export class DadosInscricoes  {
  pessoa: {
    celular: string;
    cpf: string;
    email: string;
    nome: string;
  };
  inscricoes: string[];

  constructor(args) {
    Object.assign(this, args);
  }
}
